export enum OpenpayError {
  INTERNAL_ERROR = 1000,
  BAD_REQUEST = 1001,
  UNAUTHORIZED = 1002,
  UNPROCESSABLE_ENTITY = 1003,
  SERVICE_UNAVAILABLE = 1004,
  NOT_FOUND = 1005,
  CONFLICT = 1006,
  PAYMENT_REQUIRED = 1007,
  ACCOUNT_LOCKED = 1008,
  REQUEST_TOO_LARGE = 1009,
  FORBIDDEN = 1010,
  BANK_ACCOUNT_ALREADY_REGISTERED = 2001,
  CARD_ALREADY_REGISTERED = 2002,
  EXTERNAL_ID_ALREADY_EXISTS = 2003,
  INVALID_CARD_CHECK_DIGIT = 2004,
  CARD_EXPIRED = 2005,
  INVALID_CVV = 2006,
  TEST_CARD_ONLY = 2007,
  CARD_NOT_VALID_FOR_POINTS = 2008,
  CVV_NOT_VALID = 2009,
  CARD_DECLINED = 3001,
  CARD_HAS_EXPIRED = 3002,
  INSUFFICIENT_FUNDS = 3003,
  CARD_REPORTED_AS_STOLEN = 3004,
  CARD_REPORTED_AS_FRAUDULENT = 3005,
  OPERATION_NOT_ALLOWED = 3006,
  CARD_NOT_SUPPORTED_FOR_ONLINE = 3008,
  CARD_REPORTED_AS_LOST = 3009,
  CARD_RESTRICTED_BY_BANK = 3010,
  CARD_HELD_BY_BANK = 3011,
  AUTHORIZATION_REQUIRED_BY_BANK = 3012,
}

export const OpenpayErrorMessages: Record<number, string> = {
  [OpenpayError.INTERNAL_ERROR]:
    'Ocurrió un error interno, por favor intenta nuevamente más tarde.',
  [OpenpayError.BAD_REQUEST]:
    'No pudimos procesar tu solicitud, revisa que todos los datos sean correctos.',
  [OpenpayError.UNAUTHORIZED]:
    'No autorizado, por favor verifica tus credenciales.',
  [OpenpayError.UNPROCESSABLE_ENTITY]:
    'Uno o más datos no son correctos. Por favor revisa la información ingresada.',
  [OpenpayError.SERVICE_UNAVAILABLE]:
    'El servicio no está disponible en este momento. Intenta nuevamente más tarde.',
  [OpenpayError.NOT_FOUND]: 'No se encontró el recurso solicitado.',
  [OpenpayError.CONFLICT]: 'Ya existe una transacción con este identificador.',
  [OpenpayError.PAYMENT_REQUIRED]:
    'No se pudo completar el pago. Por favor verifica los fondos o datos de la tarjeta.',
  [OpenpayError.ACCOUNT_LOCKED]:
    'Una de las cuentas requeridas está desactivada.',
  [OpenpayError.REQUEST_TOO_LARGE]:
    'La solicitud es demasiado grande. Intenta con menos datos.',
  [OpenpayError.FORBIDDEN]: 'No tienes permisos para realizar esta acción.',
  [OpenpayError.BANK_ACCOUNT_ALREADY_REGISTERED]:
    'La cuenta bancaria ya está registrada en el sistema.',
  [OpenpayError.CARD_ALREADY_REGISTERED]:
    'Esta tarjeta ya está registrada en el sistema.',
  [OpenpayError.EXTERNAL_ID_ALREADY_EXISTS]:
    'Este identificador externo ya existe.',
  [OpenpayError.INVALID_CARD_CHECK_DIGIT]: 'El número de tarjeta es inválido.',
  [OpenpayError.CARD_EXPIRED]: 'La tarjeta ha expirado.',
  [OpenpayError.INVALID_CVV]:
    'El código de seguridad (CVV) de la tarjeta no es válido.',
  [OpenpayError.TEST_CARD_ONLY]:
    'Esta tarjeta es de prueba y solo puede usarse en Sandbox.',
  [OpenpayError.CARD_NOT_VALID_FOR_POINTS]:
    'La tarjeta no es válida para puntos.',
  [OpenpayError.CVV_NOT_VALID]: 'El código de seguridad (CVV) no es válido.',
  [OpenpayError.CARD_DECLINED]:
    'La tarjeta fue declinada. Verifica los datos o fondos disponibles.',
  [OpenpayError.CARD_HAS_EXPIRED]: 'La tarjeta ha expirado.',
  [OpenpayError.INSUFFICIENT_FUNDS]: 'No hay fondos suficientes en la tarjeta.',
  [OpenpayError.CARD_REPORTED_AS_STOLEN]:
    'La tarjeta ha sido reportada como robada.',
  [OpenpayError.CARD_REPORTED_AS_FRAUDULENT]:
    'La tarjeta ha sido reportada como fraudulenta.',
  [OpenpayError.OPERATION_NOT_ALLOWED]:
    'Esta operación no está permitida para este cliente o transacción.',
  [OpenpayError.CARD_NOT_SUPPORTED_FOR_ONLINE]:
    'La tarjeta no es soportada para transacciones en línea.',
  [OpenpayError.CARD_REPORTED_AS_LOST]:
    'La tarjeta fue reportada como perdida.',
  [OpenpayError.CARD_RESTRICTED_BY_BANK]: 'El banco ha restringido la tarjeta.',
  [OpenpayError.CARD_HELD_BY_BANK]:
    'El banco ha solicitado retener la tarjeta. Contacta al banco.',
  [OpenpayError.AUTHORIZATION_REQUIRED_BY_BANK]:
    'Se requiere autorización del banco para completar el pago.',
};
